<template>
  <el-dialog title="温馨提示" :visible.sync="show" width="600px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <div style="text-align: center;height:60px">
      <img v-if="labor" src="@/assets/record/jzcg.png" alt="">
      <img v-else src="@/assets/home-search/tip.png" alt="">
    </div>
    <div style="color: #969696;font-size: 16px;text-align: center;margin-top: 20px" v-html="message">{{message}}</div>
    <div slot="footer" style="text-align: center;">
      <el-button v-if="btnEsc" @click="show=false;fun(false)" style="margin-right: 20px">取消</el-button>
      <el-button :class="labor?'buttons':'button'" type="primary" @click="show=false;fun(true)" style="margin-left: 0px" >{{ okText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  /**
   * params: showToast Boolean  是否激活toast  默认 false
   * params: type String        toast提示类型  共 success，error，warning cancel 四个选项
   * params: message String     toast消息
   * params: duration Number    toast显示时间 默认 3000ms
   * */
  name: "Tips",
  data() {
    return {
      show: false,
      message: "消息提示",
      btnEsc:true,//显示取消按钮
      fun:()=>{},
      okText:'知道了',
      labor:false
    }
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
/deep/.el-dialog__body{
  border-top: 1px solid #E4E7ED;
}
/deep/.el-dialog__body{
  border-top: 1px solid #E4E7ED;
  padding:30px 20px 20px;
}
/deep/.el-dialog__header {
  height: 42px;
  line-height: 42px;
  padding:0 20px!important;
}
/deep/.el-dialog__headerbtn {
  top: 2px;
  line-height: 42px;
}
/deep/.el-dialog__title {
  line-height: 42px;
  color: #000;
}
/deep/.el-dialog__footer{
  padding: 0 20px 20px;
}
.button {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  width: 72px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  padding: 0;
  font-size: 14px;
  &:hover,&:focus{
  color: #fff;
  border-color: #B79255;
  background: #B79255;
  }
}
.buttons {
  color: #fff;
  border-color: #0286DF;
  background: #0286DF;
  width: 72px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  padding: 0;
  font-size: 14px;
  &:hover,&:focus{
  color: #fff;
  border-color: #0286DF;
  background: #0286DF;
  }
}
</style>
